// extracted by mini-css-extract-plugin
module.exports = {"control":"Input_control__12B5W"};